<template>
  <div class="filters--sort">
    <span class="filters--sort__label">Sort by</span>
    <div class="filters--sort__control">
      <Survey :survey="survey" />
    </div>
  </div>
</template>

<script>
import * as SurveyVue from 'survey-vue'
import 'survey-vue/survey.min.css'

const Survey = SurveyVue.Survey

export default {
  name: 'FiltersSort',

  components: {
    Survey
  },

  emits: [
    'update:sort'
  ],

  data () {
    return {
      dataLoaded: true,
      survey: null,
      surveyJson: {
        elements: [
          {
            allowClear: false,
            width: '200px',
            minWidth: '200px',
            maxWidth: '200px',
            // Sort has three fixed options, so the SurveyJS search box only adds
            // confusion here. Keep it as a plain non-editable dropdown.
            searchEnabled: false,
            titleLocation: 'hidden',
            hideNumber: true,
            name: 'sort',
            type: 'dropdown',
            choices: [
              { value: 0, text: 'Most popular' },
              { value: 1, text: 'Recently published' },
              { value: 2, text: 'Alphabetical (A-Z)' }
            ]
          }
        ]
      }
    }
  },

  created () {
    this.survey = new SurveyVue.Model(this.surveyJson)
    // The backend already treats "Most popular" as the default sort, so the
    // control should show that state explicitly instead of an empty placeholder.
    this.survey.data = { sort: 0 }
    this.survey.onValueChanged.add(this.updateSelectedSort)
    this.survey.showNavigationButtons = false

    this.$root.$on('reset:sort', this.reset)
  },

  mounted () {
    this.$root.$on('data:loaded', this.populateFilters)
  },

  methods: {
    populateFilters () {
      this.dataLoaded = true
    },

    reset () {
      this.survey.data = { sort: 0 }
    },

    updateSelectedSort (sender) {
      this.$store.dispatch('search/updateSort', sender.data)
      this.$emit('update:sort')
    }
  }
}
</script>

<style scoped>
.filters--sort {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.filters--sort__label {
  flex: 0 0 auto;
  line-height: 1;
}

.filters--sort__control {
  display: flex;
  align-items: center;
}

.filters--sort__control ::v-deep(#sq_100) {
  margin-bottom: 0;
}
</style>
